import $ from 'jquery';
import Swiper, { EffectFade } from 'swiper';

function initContentImageTabs() {
  $(function () {
    if ($('.content-image-tabs').length <= 0) {
      return;
    }
    $('.content-image-tabs').each(function () {
      let slider = $(this).find('.swiper-container');
      let tabs = $(this).find('.content-image-tabs__nav-btn');

      let swiper = new Swiper(slider.get(0), {
        modules: [EffectFade], // Include EffectFade here
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        allowTouchMove: false,
        //effect: 'fade', // Make sure to set the effect as 'fade'
        fadeEffect: {
          crossFade: true // Optional: set to true for a smooth cross-fade transition
        }
      });

      tabs.on('click' , function(){
        let index = $(this).data('index');
        tabs.removeClass('active');
        $(this).addClass('active');
        swiper.slideTo(index );
      });

      tabs.first().addClass('active');
    });
  });
}

export { initContentImageTabs };